import moment from "moment";

export function createCashflowExportRow({
  user,
  cashflow,
  code,
  T,
  type,
  getCurrency,
  formatCurrency,
  formatLocalCurrency,
  convertToLocalCurrency,
  typeConvertSZT,
  typeConvertSGT,
  typeConvertNew,
  statusSZTConvert,
  statusConvert,
}) {
  const isSZT = code === "SZT";
  const isSGT = code === "SGT";
  const isSpecialToken = isSZT || isSGT;

  let itemType;
  if (isSZT) {
    itemType = typeConvertSZT(cashflow);
  } else if (isSGT) {
    itemType = typeConvertSGT(cashflow);
  } else {
    itemType = typeConvertNew(cashflow);
  }

  const status = isSpecialToken
    ? statusSZTConvert(cashflow)
    : statusConvert(cashflow);

  const feeAmount = isSZT
    ? Math.abs(cashflow.fee)
    : Math.abs(cashflow.fee_amount);

  let transactionField = "";
  if (isSpecialToken) {
    if (cashflow.transactionCode) {
      transactionField = `"${cashflow.transactionCode}"`;
    }
  } else if (cashflow.transaction_code) {
    transactionField = `"${cashflow.transaction_code}"`;
  }

  const amountWithCurrency =
    formatCurrency(cashflow.amount, null, getCurrency()) +
    (isSpecialToken ? code : cashflow.currency_code);

  const convertedAmount = isSpecialToken
    ? convertToLocalCurrency(Math.abs(cashflow.amount), code, getCurrency())
    : convertToLocalCurrency(
        Math.abs(cashflow.amount),
        cashflow.currency_code,
        getCurrency()
      );

  const localAmount = formatLocalCurrency(convertedAmount);

  let feeSuffix = "";
  console.log(cashflow.type)
  if (feeAmount > 0) {
    if (isSpecialToken) {
      feeSuffix = code;
    } else if (cashflow.type === 5) { // Internal convert/transfer
      feeSuffix = 'SZT';
    } else {
      feeSuffix = cashflow.currency_code;
    }
  }

  const feeWithCurrency =
    formatCurrency(feeAmount, null, getCurrency()) + feeSuffix;

  const createdAt = moment(
    !isSpecialToken ? cashflow.created_time : cashflow.createTime
  ).format("YYYY/MM/DD HH:mm:ss");

  const data = [
    user.id,
    user.email,
    user.name,
    transactionField,
    cashflow.from_wallet_address,
    cashflow.dest_wallet_address,
    amountWithCurrency,
    localAmount,
    feeWithCurrency,
  ];

  if (type === "option") {
    data.push(cashflow.item_id);
  }

  data.push(T(itemType).replace("{currency_code}", code));
  data.push(T(status));
  data.push(createdAt);

  return data;
}

